import { frontendURL } from '../../../../helper/URLHelper';

// Ver o comentario equivalente em contacts.js: com o prefixo do router desligado para itens com
// regra propria, as rotas de navegacao precisam ser listadas aqui.
const ALL_COMPANIES_ROUTES = [
  'companies_dashboard',
  'company_profile_dashboard',
  'companies_segments_dashboard',
];

const companies = accountId => ({
  parentNav: 'companies',
  routes: [
    'companies_dashboard',
    'company_import_spreadsheet',
    'company_wallet',
    'companies_segments_dashboard',
    'company_profile_dashboard',
  ],
  menuItems: [
    {
      icon: 'briefcase',
      label: 'ALL_COMPANIES',
      key: 'all_companies',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/companies`),
      toStateName: 'companies_dashboard',
      isActive: route => ALL_COMPANIES_ROUTES.includes(route.name),
    },
    {
      icon: 'upload',
      label: 'IMPORT_COMPANIES',
      key: 'import_companies',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/companies/import`),
      toStateName: 'company_import_spreadsheet',
      isActive: route => route.name === 'company_import_spreadsheet',
    },
    {
      icon: 'wallet-outline',
      label: 'COMPANY_WALLET',
      key: 'company_wallet',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/companies/wallet`),
      toStateName: 'company_wallet',
      isActive: route => route.name === 'company_wallet',
    },
  ],
});

export default companies;
